import I18n from 'I18n';
import PropTypes from 'prop-types';
import { createRef, Component } from 'react';
import styled from 'styled-components';
import omit from 'transmute/omit';
import getIn from 'transmute/getIn';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Typeahead } from 'foundations-components/transitional/components/Typeahead';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getHtmlBodyForOption = (id, options) => getIn(['snippet', 'htmlBody'], options.find(option => option.value === id));
const areOptionsRenderable = options => options && options.length > 0;
const LoadingPositioner = styled.div.withConfig({
  displayName: "ContentTypeahead__LoadingPositioner"
})(["align-items:center;display:flex;height:180px;justify-content:center;"]);
class ContentTypeahead extends Component {
  constructor(...args) {
    super(...args);
    this._inputRef = /*#__PURE__*/createRef();
    this.handleChange = e => {
      // @ts-expect-error ts-migrate FIXME
      const {
        onChange,
        options
      } = this.props;
      const id = e.target.value;
      const htmlBody = getHtmlBodyForOption(id, options);
      const version = options.find(option => option.value === id).version;
      onChange({
        id,
        htmlBody,
        version
      });
    };
  }
  componentDidUpdate(prevProps) {
    const {
      isLoading: wasLoading,
      options: prevOptions
    } = prevProps;
    const {
      isLoading,
      options
    } = this.props;
    const didPreviouslyRenderTypeahead = areOptionsRenderable(prevOptions);
    const isTypeaheadRendered = areOptionsRenderable(options);
    if ((!didPreviouslyRenderTypeahead && isTypeaheadRendered || wasLoading && !isLoading) && this._inputRef && this._inputRef.current) {
      this._inputRef.current.focus();
    }
  }
  renderLoadingSpinner() {
    const {
      isLoading
    } = this.props;
    if (isLoading) {
      return /*#__PURE__*/_jsx(LoadingPositioner, {
        children: /*#__PURE__*/_jsx(LoadingSpinner, {})
      });
    }
    return null;
  }
  render() {
    const {
      // @ts-expect-error ts-migrate FIXME
      EmptyState,
      // @ts-expect-error ts-migrate FIXME
      ErrorState,
      // @ts-expect-error ts-migrate FIXME
      search,
      // @ts-expect-error ts-migrate FIXME
      handleSearch,
      options,
      isLoading,
      // @ts-expect-error ts-migrate FIXME
      portalId,
      // @ts-expect-error ts-migrate FIXME
      searchPlaceHolder
    } = this.props;
    if (isLoading && search.length === 0) {
      return this.renderLoadingSpinner();
    }
    if (!options) {
      return /*#__PURE__*/_jsx(ErrorState, {
        portalId: portalId
      });
    }
    if (options.length === 0 && search.length === 0 && !isLoading) {
      return /*#__PURE__*/_jsx(EmptyState, {
        portalId: portalId
      });
    }
    return /*#__PURE__*/_jsxs(View, {
      minBlockSize: "240px",
      children: [/*#__PURE__*/_jsx(Typeahead, {
        autoFilter: false,
        options: options,
        placeholder: I18n.text(searchPlaceHolder),
        resultsClassName: "content-popover-search-results",
        searchClassName: "content-popover-search",
        onChange: this.handleChange,
        search: search,
        onSearchChange: event => handleSearch(event, omit(['results'], options))
        // TODO: remove cast when on React 19 types (HubSpotEngineering/fefw#73)
        ,
        inputRef: this._inputRef,
        hideResults: isLoading
      }), this.renderLoadingSpinner()]
    });
  }
}

// @ts-expect-error ts-migrate FIXME
ContentTypeahead.propTypes = {
  ErrorState: PropTypes.func.isRequired,
  EmptyState: PropTypes.func.isRequired,
  search: PropTypes.string,
  handleSearch: PropTypes.func,
  onChange: PropTypes.func,
  options: PropTypes.array,
  isLoading: PropTypes.bool,
  portalId: PropTypes.number.isRequired,
  searchPlaceHolder: PropTypes.string.isRequired
};
export default ContentTypeahead;